import './tailwind.css';
import 'react-toastify/dist/ReactToastify.css';
import { FunctionComponent } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import store from '~/store';
import { useAuth } from '~/hooks/useAuth';
import Login from './pages/login/KeycloackLoginForm';
import { Scripts } from './pages/scripts/Scripts';
import { SIMPLContract } from './pages/contracts/SIMPLContracts';
import { SIMPLCloudEnvironment } from './pages/cloud/CloudEnvironment';
import { CloudProvisionerTemplatePage } from './pages/cloud/provisioner/CloudProvisionerTemplatePage';
import { SIMPLVmConfiguration } from './pages/vm/submenu/vm-configuration/SimplVmConfiguration';
import { SIMPLVmTemplate } from './pages/vm/VmTemplate';
import { SIMPLVmPolicies } from './pages/vm/submenu/policies/SimplVmPolicies';
import { SimplVmPostProviosing } from './pages/vm/submenu/post-provisioning/SimplVmProvisioning';

const App: FunctionComponent = () => {
  return (
    <div className="text-theme-gray">
      <Provider store={store}>
        <ToastContainer />
        <BrowserRouter>
          <AuthRoutes />
        </BrowserRouter>
      </Provider>
    </div>
  );
};

const AuthRoutes: FunctionComponent = () => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return <div>Loading...</div>;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/scripts"
        element={isAuthenticated ? <Scripts /> : <Navigate to="/login" replace />}
      />
      <Route path="/" element={<Navigate to="/scripts" replace />} />
      <Route
        path="/contracts"
        element={isAuthenticated ? <SIMPLContract /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/cloud-environment"
        element={isAuthenticated ? <SIMPLCloudEnvironment /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/cloud-provisioner-template"
        element={isAuthenticated ? <CloudProvisionerTemplatePage /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/vm-template/configuration"
        element={isAuthenticated ? <SIMPLVmConfiguration /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/vm-template/management"
        element={isAuthenticated ? <SIMPLVmTemplate /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/vm-template/post-provisioning"
        element={isAuthenticated ? <SimplVmPostProviosing /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/vm-template/policies"
        element={isAuthenticated ? <SIMPLVmPolicies /> : <Navigate to="/login" replace />}
      />
    </Routes>
  );
};

export default App;